// @flow

import EntitySchema from 'normalizr/lib/EntitySchema';
import IterableSchema from 'normalizr/lib/IterableSchema';
// @TODO handle unionSchema and Valueof if necessary

export function Denormalizer() {
  this.localCache = new Map();
}

Denormalizer.prototype.getNormalizedObj = function getNormalizedObj(id, schema, state) {
  return state.data[schema.getKey()][id];
};

Denormalizer.prototype.getSignificantEntries = function getSignificantEntries(obj, schema) {
  return Object
    .entries(schema)
    .filter(arg => arg[0][0] !== '_')
    .filter(arg => obj[arg[0]] !== undefined);
};

Denormalizer.prototype.getDependencies = function getDependencies(id, schema, state) {
  const originalObject = this.getNormalizedObj(id, schema, state);
  const result = {};

  this.getSignificantEntries(originalObject, schema)
    .forEach(([name, nestedSchema]) => {
      result[name] = this.denormalize(originalObject[name], nestedSchema, state);
    });

  return result;
};

Denormalizer.prototype.areEquals = function areEquals(objA, objB) {
  if (objA === objB) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null ||
    typeof objB !== 'object' || objB === null) {
    return false;
  }

  const keysA = Object.keys(objA);
  const keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  for (let i = 0; i < keysA.length; i++) {
    if (!objB.hasOwnProperty(keysA[i])) {
      return false;
    }

    const valueA = objA[keysA[i]];
    const valueB = objB[keysA[i]];
    const valuesAreEquals = Array.isArray(valueB) ?
      (
        Array.isArray(valueA) &&
        valueB.length === valueA.length &&
        valueB.every((item, index) => item === valueA[index])
      ) :
      valueA === valueB;

    if (!valuesAreEquals) {
      return false;
    }
  }

  return true;
};

Denormalizer.prototype.denormalizeEntity = function denormalizeEntity(id, schema, state) {
  const originalObject = this.getNormalizedObj(id, schema, state);

  if (originalObject === undefined) {
    const result = { id };

    this.getSignificantEntries(schema, schema)
    .forEach(([name, nestedSchema]) => {
      result[name] = nestedSchema instanceof IterableSchema ? [] : {};
    });

    return result;
  }

  const memoizedData = this.localCache.get(originalObject);
  const dependencies = this.getDependencies(id, schema, state);

  if (!!memoizedData && this.areEquals(dependencies, memoizedData.dependencies)) {
    return memoizedData.data;
  }

  const newData = { ...originalObject, ...dependencies };
  this.localCache.set(originalObject, {
    data: newData,
    dependencies,
  });

  return newData;
};

Denormalizer.prototype.denormalizeIterable = function denormalizeEntity(ids, schema, state) {
  if (!Array.isArray(ids)) return {};

  const itemSchema = schema.getItemSchema();
  return ids.map(id => this.denormalize(id, itemSchema, state));
};

Denormalizer.prototype.denormalize = function denormalize(ids, schema, state) {
  if (schema instanceof IterableSchema) {
    return this.denormalizeIterable(ids, schema, state);
  }

  if (schema instanceof EntitySchema) {
    return this.denormalizeEntity(ids, schema, state);
  }

  return {};
};

export default function getDenormalizer() {
  const denormalizer = new Denormalizer();
  return function denormalize(ids: IdType, schema: any, state: Object) {
    return denormalizer.denormalize(ids, schema, state);
  };
}



// WEBPACK FOOTER //
// ./~/virgo/src/utils/getDenormalizer.js